import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, ArrowUpIcon, HomeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0F172A] text-slate-400 py-16 md:py-24 px-6 md:px-12 lg:px-16 pb-32 md:pb-24 relative" data-id="element-99">
      <div className="max-w-7xl mx-auto" data-id="element-100">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b border-white/10 pb-12 mb-12" data-id="element-101">
          <div className="mb-8 md:mb-0" data-id="element-102">
            <div className="flex items-center gap-2.5 mb-4" data-id="element-103">
              <span className="bg-[#D4A24C] text-white p-2 rounded-xl shadow-sm flex items-center justify-center" data-id="element-104">
                <HomeIcon className="w-5 h-5" data-id="element-105" />
              </span>
              <span className="font-display text-white text-2xl md:text-[26px] tracking-wide" data-id="element-106">
                NATIONWIDE <span className="text-[#D4A24C]" data-id="element-107">HOME BUYERS</span>
              </span>
            </div>
            <p className="text-lg text-slate-300 max-w-md font-light" data-id="element-108">
              We buy houses for cash in all 50 states — fast, fair, and as-is.
            </p>
          </div>
          <div className="flex gap-4" data-id="element-109">
            <a href="#" className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A24C] hover:text-white transition-colors" data-id="element-110">
              <FacebookIcon className="w-5 h-5" data-id="element-111" />
            </a>
            <a href="#" className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A24C] hover:text-white transition-colors" data-id="element-112">
              <TwitterIcon className="w-5 h-5" data-id="element-113" />
            </a>
            <a href="#" className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A24C] hover:text-white transition-colors" data-id="element-114">
              <InstagramIcon className="w-5 h-5" data-id="element-115" />
            </a>
            <a href="#" className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A24C] hover:text-white transition-colors" data-id="element-116">
              <LinkedinIcon className="w-5 h-5" data-id="element-117" />
            </a>
          </div>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-118">
          <div id="about" className="md:col-span-2 scroll-mt-24" data-id="element-119">
            <h4 className="text-white font-semibold mb-6 text-lg" data-id="element-120">About Us</h4>
            <p className="mb-6 max-w-md leading-relaxed" data-id="element-121">
              We are a nationwide real estate investment company that buys
              houses for cash in all 50 states. We provide win-win solutions to
              help homeowners get out of their sticky situations without the
              traditional market hassles.
            </p>
          </div>

          <div data-id="element-122">
            <h4 className="text-white font-semibold mb-6 text-lg" data-id="element-123">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-124">
              <li className="flex items-center" data-id="element-125">
                <PhoneIcon className="w-5 h-5 mr-3 flex-shrink-0 text-[#D4A24C]" data-id="element-126" />
                <a href="tel:+18556052101" className="hover:text-white transition-colors" data-id="element-127">
                  1-855-605-2101
                </a>
              </li>
              <li className="flex items-center" data-id="element-128">
                <MailIcon className="w-5 h-5 mr-3 flex-shrink-0 text-[#D4A24C]" data-id="element-129" />
                <a href="mailto:info@nationwidehomebuyers.com" className="hover:text-white transition-colors" data-id="element-130">
                  info@nationwidehomebuyers.com
                </a>
              </li>
              <li className="flex items-start" data-id="element-131">
                <MapPinIcon className="w-5 h-5 mr-3 mt-1 flex-shrink-0 text-[#D4A24C]" data-id="element-132" />
                <span className="leading-relaxed" data-id="element-133">
                  7901 4th St N ste 300 St Petersburg, FL 33702 (HQ)
                </span>
              </li>
            </ul>
          </div>

          <div id="where-we-buy" className="scroll-mt-24" data-id="element-134">
            <h4 className="text-white font-semibold mb-6 text-lg" data-id="element-135">
              Where We Buy
            </h4>
            <p className="text-sm mb-3" data-id="element-136">We buy homes in all 50 states.</p>
            <ul className="space-y-3" data-id="element-137">
              <li data-id="element-138">Northeast</li>
              <li data-id="element-139">Southeast</li>
              <li data-id="element-140">Midwest</li>
              <li data-id="element-141">Southwest</li>
              <li data-id="element-142">West Coast</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10 text-sm flex flex-col md:flex-row justify-between items-center relative" data-id="element-143">
          <p data-id="element-144">
            &copy; {new Date().getFullYear()} NationwideHomeBuyers.com. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-6 md:mt-0" data-id="element-145">
            <a href="#/privacy" className="hover:text-white transition-colors" data-id="element-146">
              Privacy Policy
            </a>
            <a href="#/terms" className="hover:text-white transition-colors" data-id="element-147">
              Terms of Service
            </a>
          </div>

          {/* Back to top */}
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="absolute right-0 -top-6 md:top-auto md:relative w-10 h-10 bg-white/5 hover:bg-[#D4A24C] text-white rounded-full flex items-center justify-center transition-colors" aria-label="Back to top" data-id="element-148">
            <ArrowUpIcon className="w-5 h-5" data-id="element-149" />
          </button>
        </div>
      </div>
    </footer>;
}